// src/Redux/Reducers/StageCalculatorReducer.js
import {
  FETCH_STAGE_CALCULATOR_REQUEST,
  FETCH_STAGE_CALCULATOR_SUCCESS,
  FETCH_STAGE_CALCULATOR_FAILURE,
  UPDATE_STAGE_CALCULATOR_REQUEST,
  UPDATE_STAGE_CALCULATOR_SUCCESS,
  UPDATE_STAGE_CALCULATOR_FAILURE,
  CREATE_STAGE_CALCULATOR_REQUEST,     // NEW
  CREATE_STAGE_CALCULATOR_SUCCESS,     // NEW
  CREATE_STAGE_CALCULATOR_FAILURE,     // NEW
} from "../Types/ActionTypes";

const initialState = {
  loading: false,
  data: null,        // Expected format: { data: [ ...rows ] }
  error: null,
};

export const stageCalculatorReducer = (state = initialState, action) => {
  switch (action.type) {
    // --------------------------------------------------------------
    // REQUEST STATES
    // --------------------------------------------------------------
    case FETCH_STAGE_CALCULATOR_REQUEST:
    case UPDATE_STAGE_CALCULATOR_REQUEST:
    case CREATE_STAGE_CALCULATOR_REQUEST:
      return { ...state, loading: true, error: null };

    // --------------------------------------------------------------
    // SUCCESS STATES
    // --------------------------------------------------------------
    case FETCH_STAGE_CALCULATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload, // e.g. { data: [ ... ] }
      };

    case UPDATE_STAGE_CALCULATOR_SUCCESS:
      // Replace the updated row in the array
      const updatedRow = action.payload;
      const updatedData = state.data?.data?.map((row) =>
        row.id === updatedRow.id ? updatedRow : row
      ) || [updatedRow];

      return {
        ...state,
        loading: false,
        data: { ...state.data, data: updatedData },
      };

    case CREATE_STAGE_CALCULATOR_SUCCESS:
      // Append the newly created row
      const newRow = action.payload;
      const newDataArray = [...(state.data?.data || []), newRow];

      return {
        ...state,
        loading: false,
        data: { ...state.data, data: newDataArray },
      };

    // --------------------------------------------------------------
    // FAILURE STATES
    // --------------------------------------------------------------
    case FETCH_STAGE_CALCULATOR_FAILURE:
    case UPDATE_STAGE_CALCULATOR_FAILURE:
    case CREATE_STAGE_CALCULATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};